import {Component, ElementRef, HostListener, OnInit, ViewChild, AfterViewInit} from '@angular/core';
import {Router, NavigationEnd} from '@angular/router';
import {Location, LocationStrategy, PathLocationStrategy} from '@angular/common';
import {NewsService} from "../../../shared/services/news.service";
import {filter} from "rxjs/operators";

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    providers: [
        Location, {
            provide: LocationStrategy,
            useClass: PathLocationStrategy
        }
    ]
})
export class HeaderComponent implements OnInit, AfterViewInit {
    @ViewChild('myDiv') myDiv!: ElementRef;
    isMenuOpen = true;
    location: any;
    navClass: any;
    listClass: any;
    logo: any;
    navContainer: any;
    selectedImage: any;
    selectedText: any;
    activeMenuItem: string = '';

    phoneViewMenuOpen = false;
    aboutus = false;
    academics = false;
    research = false;
    admission = false;
    lifearni = false;
    examination = false;
    iqac = false;
    newsData: any;
    menuOpen: boolean = false;
    activeSchoolIndex = 0;
    submenuOpen: { [key: number]: { [key: number]: boolean } } = {};
    MenuDetail = [
        {
            name: 'Arni School of Technology',
            schoolDetail: [
                {
                    name: 'About Us',
                    link: '/ast'
                },
                {
                    name: 'Syllabus',
                    link: '/ast-syllabus'
                },
                {
                    name: 'Department',
                    submenu: [
                        {
                            name: 'Civil Engineering',
                            link: '/ast-civil-engineering'
                        },
                        {
                            name: 'Mechanical Engineering',
                            link: '/ast-civil-engineering'
                        },
                        {
                            name: 'Computer Science Engineering',
                            link: '/ast-computer-science-engineering'
                        },
                        {
                            name: 'Computer Science & Application',
                            link: '/ast-computer-science-application'
                        },
                        {
                            name: 'ECE & EE',
                            link: '/ast-ece-ee'
                        },
                        {
                            name: 'Cyber Security and AI',
                            link: '/ast-cyber-security'
                        }
                    ]
                },
                {
                    name: 'Contact Us',
                    link: 'ast-contactus'
                }],
            schoolContent:
                [{
                    image: 'assets/img/ArniSchool01/14.jpg',
                    content: 'Welcome to The ARNI School of Technologies (AST), the place where ideas turn into reality. The students seeking careers in a variety of technological sectors can learn postgraduate and undergraduate courses in Arni University. We have a long-term vision to craft a transformative learning environment where students are not just taught technical skills but are provided with relevant exposure that helps them to lead and drive growth in the technological landscape. We are on a mission to spread knowledge and skills that empower students in this dynamic field of technology and innovations. We aim to provide them with a platform that encourages interdisciplinary collaboration, hands-on learning, and research-driven exploration.'
                }]
        },
        {
            name: 'Arni School of Business Management & Commerce',
            schoolDetail: [
                {
                    name: 'About Us',
                    link: '/asbmc'
                },
                {
                    name: 'Syllabus',
                    link: '/asbmc-syllabus'
                },
                {
                    name: 'Department',
                    submenu: [
                        {
                            name: 'Business Studies',
                            link: '/asbmc-business-studies'
                        },
                        {
                            name: 'Commerce',
                            link: '/asbmc-commerce'
                        },
                        {
                            name: 'Hospitality Management',
                            link: '/asbmc-hospitality-management'
                        },
                    ]
                },
                {
                    name: 'Contact Us',
                    link: 'asbmc-contactus'
                }],
            schoolContent:
                [{
                    image: 'assets/img/ArniSchool02/4%20(1).jpg',
                    content: 'The ARNI School of Business Management & Commerce is the place where potential leaders transform into business professionals. Students looking to pursue their career in the field of business and finance management opt for ‘The School of Business Management & Commerce degree courses from ARNI University division. Our approach to encouraging future leaders, entrepreneurs, and professionals is not only to shape the business world but to also contribute to economic, social, and environmental progress. Our programs are designed to equip students with the necessary skills and knowledge in this fast-paced business world.'
                }]
        },
        {
            name: 'Arni School of Art & Humanities',
            schoolDetail: [
                {
                    name: 'About Us',
                    link: '/asah'
                },
                {
                    name: 'Syllabus',
                    link: '/asah-syllabus'
                },
                {
                    name: 'Department',
                    submenu: [
                        {
                            name: 'English',
                            link: '/asah-english'
                        },
                        {
                            name: 'Education',
                            link: '/asah-education'
                        },
                        {
                            name: 'Library Science',
                            link: '/asah-library-science'
                        },
                        {
                            name: 'Journalism & Mass Communication',
                            link: '/asah-journalism-and-mass-communication'
                        },
                        {
                            name: 'Design',
                            link: '/asah-fashion-design'
                        },
                        {
                            name: 'Yoga Science',
                            link: '/asah-yoga-science'
                        },
                        {
                            name: 'Vocational Courses',
                            link: '/asah-vocational-course'
                        },
                    ]
                },
                {
                    name: 'Contact Us',
                    link: 'asah-contactus'
                }],
            schoolContent:
                [{
                    image: 'assets/img/ArniSchool03/1.jpg',
                    content: 'The School of Arts and Humanities at ARNI University is the place where culture, communication, and creativity take flite to the diversified career opportunities. Arts and Humanities courses offer an enriching blend of disciplines in the arts, literature, philosophy, social science, political science, and history. We are aiming to provide a strong base for creative minds who are passionate about the understanding complexities of human experience, culture, and society, while equipping them with the critical thinking skills and perspectives to thrive in today’s fast-changing world.\n' +
                        '\n'
                }]
        },
        {
            name: 'Arni School of Basic Sciences & Bio-Technology',
            schoolDetail: [
                {
                    name: 'About Us',
                    link: '/asbsbt'
                },
                {
                    name: 'Syllabus',
                    link: '/asbsbt-syllabus'
                },
                {
                    name: 'Department',
                    submenu: [
                        {
                            name: 'Physics',
                            link: '/asbsbt-physical-science'
                        },
                        {
                            name: 'Life Science',
                            link: '/asbsbt-life-science'
                        },
                        {
                            name: 'Chemistry',
                            link: '/asbsbt-chemistry'
                        },
                        {
                            name: 'Maths',
                            link: '/asbsbt-maths'
                        },
                    ]
                },
                {
                    name: 'Contact Us',
                    link: 'asbsbt-contact'
                }],
            schoolContent:
                [{
                    image: 'assets/img/ArniSchool04/1.jpg',
                    content: 'Welcome to The ARNI School of Basic Science & Biotechnology, the intersection of innovation and inquiry. It offers a nourished ground for aspiring researchers, biotechnologists, and scientists. The learning of the school is devoted to unraveling the mysterious world of science and the universe through cutting-edge research and education in disciplines like physics, chemistry, mathematics, and biotechnology. The school is designed to offer numerous BSC life science programs.\n' +
                        '\n'
                }]
        },
        {
            name: 'Arni School of Allied Health Sciences',
            schoolDetail: [
                {
                    name: 'About Us',
                    link: '/asahs'
                },
                {
                    name: 'Syllabus',
                    link: '/asahs-syllabus'
                },
                {
                    name: 'Department',
                    submenu: [
                        {
                            name: 'Radiology',
                            link: '/asahs-radiology'
                        },
                        {
                            name: 'Operation Theatre Technology',
                            link: '/asahs-ott'
                        },
                        {
                            name: 'Anesthesia',
                            link: '/asahs-anesthesia'
                        },
                        {
                            name: 'Optometry',
                            link: '/asahs-optometry'
                        },
                        {
                            name: 'MLT',
                            link: '/asahs-mlt'
                        },
                        {
                            name: 'Physiotherapy',
                            link: '/asahs-physiotherapy'
                        },
                        {
                            name: 'NYS',
                            link: '/asahs-yogasci'
                        },
                    ]
                },
                {
                    name: 'Contact Us',
                    link: 'asahs-contact'
                }],
            schoolContent:
                [{
                    image: 'assets/img/ArniSchool05/1.jpg',
                    content: 'The ARNI School of Allied Health Sciences provides a dynamic learning environment that merges theoretical knowledge with practical skills and practice to train students for the healthcare industry. The school is dedicated to shaping fully skilled healthcare professionals who embrace the medical field with expertise, compassion, and technology. Allied science plays a pivotal role in medical treatment, handling treatment, illness prevention, and diagnosing. With programs such as BSc in allied health sciences, they are ready to contribute significantly to the healthcare sector for the betterment of society.\n' +
                        '\n'
                }]
        }

        ,
        {
            name: 'Arni School of Pharmacy',
            schoolDetail:
                [
                    {
                        name: 'About Us',
                        link: '/asp'
                    },
                    {
                        name: 'Syllabus',
                        link: '/asp-syllabus'
                    },
                    {
                        name: 'Department',
                        submenu: [
                            {
                                name: 'Pharmacy',
                                link: '/asp-pharmacy'
                            },
                        ]
                    },
                    {
                        name: 'Contact Us',
                        link: 'asp-contact'
                    }],
            schoolContent:
                [{
                    image: 'assets/img/ArniSchool05/1.jpg',
                    content: 'ARNI School of Pharmacy stands as a pillar of excellence in pharmaceutical education, research, and healthcare innovations. With a strong commitment to advancing the field of pharmacy, we empower students to become professionally skilled workers who are dedicated to improving public health and wellbeing. Through the course, students are well-prepared to meet and resolve the challenges of the pharmaceutical industry and healthcare sector from drug development to clinical research and patient care. The Bachelors of Science in Pharmacy from ARNI University explore meaningful careers in a rapidly evolving field.\n' +
                        '\n'
                }]
        }
        ,
        {
            name: 'Arni School of Agriculture',
            schoolDetail:
                [
                    {
                        name: 'About Us',
                        link: '/asa'
                    },
                    {
                        name: 'Syllabus',
                        link: '/asa-syllabus'
                    },
                    {
                        name: 'Department',
                        submenu: [
                            {
                                name: 'Agriculture',
                                link: '/asa-agriculture'
                            },
                        ]
                    },
                    {
                        name: 'Contact Us',
                        link: 'asa-contact'
                    }],
            schoolContent:
                [{
                    image: 'assets/img/ArniSchool07/1.jpg',
                    content: 'ARNI The School of Agriculture is dedicated to preparing the upcoming generation of agriculture leaders and researchers who will lead the future of sustainable farming, rural development, and food security. The school nestled with rich biodiversity and agricultural heritage, provides an appropriate setup for the students to learn, experiment, and grow as professionals bound to transform the agriculture landscape in a better and more compelling way. Through the School, ARNI trains students to become catalysts in the field of agriculture with a strong emphasis on research, technology integration, and experimental learning. Our students are cultivated through industry interactions and entrepreneurial skill development initiatives, fostering a culture of innovation and leadership.\n' +
                        '\n'
                }]
        }
        ,
        {
            name: 'Arni School of Law',
            schoolDetail:
                [
                    {
                        name: 'About Us',
                        link: '/asl'
                    },
                    {
                        name: 'Syllabus',
                        link: '/asl-syllabus'
                    },
                    {
                        name: 'Department',
                        submenu: [
                            {
                                name: 'Legal Studies',
                                link: '/asl-legal-studies'
                            }
                        ]
                    },
                    {
                        name: 'Contact Us',
                        link: 'asl-contact'
                    }],
            schoolContent:
                [{
                    image: 'assets/img/ArniSchool08/1.jpg',
                    content: 'Since many years, the ARNI School of Law has been termed as the best place to nurture future leaders in legal practices among many other Law Colleges. The school is designed to deliver profound legal knowledge, analytics abilities, and ethical values. Rooted in a multidisciplinary approach, the ARNI School of Law combines theoretical learning with practical skills, offering comprehensive education in criminal justice, constitutional law, human rights, corporate law, and more. With a strong emphasis on critical thinking, legal research, and experiential learning, the School prepares students to meet the demands of a dynamic legal landscape for those aspiring to bring justice and positive change to society. Arni School of Law has come out as a leading institution in shaping the future of legal professionals by providing a comprehensive understanding of legal principles and practices.\n' +
                        '\n'
                }]
        }
        ,
        {
            name: 'Arni School of Hotel Management & Tourism',
            schoolDetail:
                [
                    {
                        name: 'About Us',
                        link: '/ashmt'
                    },
                    {
                        name: 'Syllabus',
                        link: '/ashmt-syllabus'
                    },
                    {
                        name: 'Department',
                        submenu: [
                            {
                                name: 'Hotel & Tourism',
                                link: '/ashmt-toursim-and-Hospitality-Management'
                            },
                        ]
                    },
                    {
                        name: 'Contact Us',
                        link: 'ashmt-contact'
                    }],
            schoolContent:
                [{
                    image: 'assets/img/ArniSchool07/1.jpg',
                    content: 'The ARNI School of Hotel Management is a vibrant hub of aspiring hospitality professionals, combining creativity, professionalism, and a global outlook. The way the hospitality industry growing rapidly, the need for industry professionals has shot up drastically. The school is committed to producing highly professionals with relevant skills, confidence, and adaptable nature that can excel in a competitive environment. We pride ourselves on offering a dynamic learning environment that integrates academic rigor with hands-on training. From culinary arts to front office management, and event planThe ARNI School of Hotel Management is a vibrant hub of aspiring hospitality professionals, combining creativity, professionalism, and a global outlook. The way the hospitality industry growing rapidly, the need for industry professionals has shot up drastically. '
                }]
        }
        ,
        {
            name: 'Arni School of Education & Sports',
            schoolDetail:
                [
                    {
                        name: 'About Us',
                        link: '/ases'
                    },
                    {
                        name: 'Syllabus',
                        link: '/ases-syllabus'
                    },
                    {
                        name: 'Department',
                        submenu: [
                            {
                                name: 'Sports',
                                link: '/ases-physical-application'
                            },
                        ]
                    },
                    {
                        name: 'Contact Us',
                        link: 'ases-contact'
                    }],
            schoolContent:
                [{
                    image: 'assets/img/ArniSchool05/1.jpg',
                    content: 'The ARNI School of Education and Sports is a combination of teaching physical education with science. We believe that education is not just limited to academic achievements but also fosters holistic development through physical fitness, mental well-being, and team spirit. The school is completely dedicated to preparing future educators and sports professionals who can inspire and honor the nation,lead integrity and passion. With a team of focused and well-established educators, our goal is to provide contemporary pedagogies, inclusive education, and advanced sports training. We are the best physical education colleges in india among others.\n' +
                        '\n'
                }]
        }
        ,
        {
            name: 'Staff Detail',
            schoolDetail:
                [
                    {
                        name: 'Teaching',
                        link: '/faculty-information'
                    },
                    {
                        name: 'Non Teaching',
                        link: '/non-teaching-staff'
                    }],
            schoolContent:
                [{
                    image: 'https://arnistatic.s3.ap-south-1.amazonaws.com/website/docs/gallery/XcXqReLTqQ5whlAGkCXkQMoAjjOs33REBhyMD4cD.jpg',
                    content: 'The university was founded to satisfy the goals of the residents of Kangra District in Himachal Pradesh in light of the country\'s need for skilled labor, as envisioned by the Knowledge Commission. The largest district in Himachal Pradesh is Kangra, and as of right now, there are no higher education options within 200 kilometers. Therefore, the university will be able to train the increasing number of students who would otherwise have to go to Amritsar, Chandigarh, Jalandhar, and even Gwalior in M P.'
                }]
        }
        ,
        {
            name: 'Programmes',
            link:
                '/programmes'
        }
        ,
        {
            name: 'Placement',
            link:
                '/placement'
        }
        ,
        {
            name: 'Alumni',
            link:
                '/student-info-detail'
        }
        ,
        {
            name: 'Infrastructure',
            link:
                '/infrastructure'
        }

    ]


    constructor(
        public router: Router,
        location
        :
        Location,
        private elementRef: ElementRef,
        private newsService: NewsService,
    ) {
        this.router.events
            .subscribe((event) => {
                if (event instanceof NavigationEnd) {
                    this.location = this.router.url;
                    if (this.location == '/') {
                        this.navClass = 'navbar-area';
                        this.listClass = '';
                        this.navContainer = 'container-fluid';
                        this.logo = 'assets/img/v001 WHITE TEXT LOGO-01.png';
                    } else if (this.location == '/about') {
                        this.navClass = 'navbar-area';
                        this.listClass = '';
                        this.navContainer = 'container-fluid';
                        this.logo = 'assets/img/v001 WHITE TEXT LOGO-01.png';
                    } else if (this.location == '/contact') {
                        this.navClass = 'navbar-area';
                        this.listClass = '';
                        this.navContainer = 'container-fluid';
                        this.logo = 'assets/img/v001 WHITE TEXT LOGO-01.png';
                    } else if (this.location == '/ad-gallery') {
                        this.navClass = 'navbar-area';
                        this.listClass = '';
                        this.navContainer = 'container-fluid';
                        this.logo = 'assets/img/v001 WHITE TEXT LOGO-01.png';
                    } else if (this.location == '/faq') {
                        this.navClass = 'navbar-area';
                        this.listClass = '';
                        this.navContainer = 'container-fluid';
                        this.logo = 'assets/img/v001 WHITE TEXT LOGO-01.png';
                    } else if (this.location == '/careers') {
                        this.navClass = 'navbar-area';
                        this.listClass = '';
                        this.navContainer = 'container-fluid';
                        this.logo = 'assets/img/v001 WHITE TEXT LOGO-01.png';
                    } else if (this.location == '/services') {
                        this.navClass = 'navbar-area';
                        this.listClass = '';
                        this.navContainer = 'container-fluid';
                        this.logo = 'assets/img/v001 WHITE TEXT LOGO-01.png';
                    } else if (this.location == '/projects') {
                        this.navClass = 'navbar-area';
                        this.listClass = '';
                        this.navContainer = 'container-fluid';
                        this.logo = 'assets/img/v001 WHITE TEXT LOGO-01.png';
                    } else if (this.location == '/blog') {
                        this.navClass = 'navbar-area';
                        this.listClass = '';
                        this.navContainer = 'container-fluid';
                        this.logo = 'assets/img/v001 WHITE TEXT LOGO-01.png';
                    } else if (this.location == '/ums') {
                        this.navClass = 'bg-white navbar-area';
                        this.listClass = 'text-black';
                        this.navContainer = 'container-fluid';
                        this.logo = 'assets/img/white-volmint-logo.png';
                    } else if (this.location == '/acricent') {
                        this.navClass = 'bg-white navbar-area';
                        this.listClass = 'text-black';
                        this.navContainer = 'container-fluid';
                        this.logo = 'assets/img/white-volmint-logo.png';
                    } else if (this.location == '/enroll') {
                        this.navClass = 'bg-white navbar-area';
                        this.listClass = 'text-black';
                        this.navContainer = 'container-fluid';
                        this.logo = 'assets/img/white-volmint-logo.png';
                    } else if (this.location == '/ad-gallery') {
                        this.navClass = 'bg-white navbar-area';
                        this.listClass = 'text-black';
                        this.navContainer = 'container-fluid';
                        this.logo = 'assets/img/white-volmint-logo.png';
                    } else if (this.location == '/vcalling') {
                        this.navClass = 'bg-white navbar-area';
                        this.listClass = 'text-black';
                        this.navContainer = 'container-fluid';
                        this.logo = 'assets/img/white-volmint-logo.png';
                    } else if (this.location == '/cms') {
                        this.navClass = 'bg-white navbar-area';
                        this.listClass = 'text-black';
                        this.navContainer = 'container-fluid';
                        this.logo = 'assets/img/white-volmint-logo.png';
                    } else if (this.location == '/careers/careers-details') {
                        this.navClass = 'bg-white navbar-area';
                        this.listClass = 'text-black';
                        this.navContainer = 'container-fluid';
                        this.logo = 'assets/img/white-volmint-logo.png';
                    } else if (this.location == '/cgms') {
                        this.navClass = 'bg-white navbar-area';
                        this.listClass = 'text-black';
                        this.navContainer = 'container-fluid';
                        this.logo = 'assets/img/white-volmint-logo.png';
                    } else if (this.location == '/argus') {
                        this.navClass = 'bg-white navbar-area';
                        this.listClass = 'text-black';
                        this.navContainer = 'container-fluid';
                        this.logo = 'assets/img/white-volmint-logo.png';
                    } else if (this.location == '/ims') {
                        this.navClass = 'bg-white navbar-area';
                        this.listClass = 'text-black';
                        this.navContainer = 'container-fluid';
                        this.logo = 'assets/img/white-volmint-logo.png';
                    } else if (this.location == '/lms') {
                        this.navClass = 'bg-white navbar-area';
                        this.listClass = 'text-black';
                        this.navContainer = 'container-fluid';
                        this.logo = 'assets/img/white-volmint-logo.png';
                    } else if (this.location == '/eclinic') {
                        this.navClass = 'bg-white navbar-area';
                        this.listClass = 'text-black';
                        this.navContainer = 'container-fluid';
                        this.logo = 'assets/img/white-volmint-logo.png';
                    } else if (this.location == '/machine-learning') {
                        this.navClass = 'navbar-area navbar-style-three';
                        this.navContainer = 'container';
                        this.logo = 'assets/img/v001 WHITE TEXT LOGO-01.png';
                    } else if (this.location == '/machine-learning-2') {
                        this.navClass = 'navbar-area navbar-style-four';
                        this.navContainer = 'container-fluid';
                        this.logo = 'assets/img/v001 WHITE TEXT LOGO-01.png';
                    } else if (this.location == '/home-5') {
                        this.navClass = 'navbar-area navbar-style-three';
                        this.navContainer = 'container';
                        this.logo = 'assets/img/v001 WHITE TEXT LOGO-01.png';
                    } else if (this.location == '/home-6' || this.location == '/home-7') {
                        this.navClass = 'navbar-area navbar-area-with-position-relative';
                        this.navContainer = 'container-fluid';
                        this.logo = 'assets/img/v001 WHITE TEXT LOGO-01.png';
                    } else if (this.location == '/home-8') {
                        this.navClass = 'navbar-area navbar-style-three navbar-area-with-position-relative';
                        this.navContainer = 'container-fluid';
                        this.logo = 'assets/img/v001 WHITE TEXT LOGO-01.png';
                    } else {
                        this.navClass = 'navbar-area navbar-style-two';
                        this.navContainer = 'container';
                        this.logo = 'assets/img/v001 WHITE TEXT LOGO-01.png';
                    }
                }
            });
        this.router.events.subscribe(event => {
            if (event instanceof NavigationEnd) {
                this.closeMenu();
                // this.menuOpen = false
                this.menuOpen = true;
                this.closeMenuOnClick()
                this.activeMenuItem = '';
            }

        });
    }

    ngOnInit() {
        this.getNews();
        this.router.events
            .pipe(filter(event => event instanceof NavigationEnd))
            .subscribe((event: NavigationEnd) => {
                if (event.url == '/') {
                    this.checkIfDivTouchesTop();
                } else {
                    this.myDiv.nativeElement.classList.add('bg-gradient-header');
                }
            });
    }

    ngAfterViewInit() {
        this.checkIfDivTouchesTop();
    }

    @HostListener('window:scroll', [])
    onScroll() {
        this.checkIfDivTouchesTop();
    }

    checkIfDivTouchesTop() {
        this.myDiv.nativeElement.classList.remove('bg-gradient-header');
        this.myDiv.nativeElement.classList.remove('background-color');
        const divTop = this.myDiv.nativeElement.getBoundingClientRect().top;
        if (divTop < 0) {
            this.myDiv.nativeElement.classList.add('bg-gradient-header');
        } else {
            if (this.router.url == '/') {
                this.myDiv.nativeElement.classList.add('background-color');
            } else {
                this.myDiv.nativeElement.classList.add('bg-gradient-header');
            }
        }
    }

    resetSubmenuOpenStatus() {
        this.submenuOpen = {};
    }

    closeMenuOnClick() {
        this.menuOpen = false;
    }

    changeAboutus() {
        this.aboutus = !this.aboutus;
        console.log(this.aboutus);
    }


    setActiveSchool(index
                    :
                    number
    ) {
        this.activeSchoolIndex = index;
    }


    toggleSubmenu(schoolIndex
                  :
                  number, detailIndex
                  :
                  number
    ) {
        if (!this.submenuOpen[schoolIndex]) {
            this.submenuOpen[schoolIndex] = {};
        }
        this.submenuOpen[schoolIndex][detailIndex] = !this.submenuOpen[schoolIndex][detailIndex];
    }

    getNews() {
        this.newsService.get({status: 'ACTIVE'}).subscribe(data => {
            if (data && data['data'].length > 0) {
                this.newsData = data['data'];
            }
        })
    }

    toggleMenu() {
        this.isMenuOpen = !this.isMenuOpen;
    }

    closeMenu() {
        this.isMenuOpen = false;
    }

    changeContent(image
                  :
                  string, text
                  :
                  string
    ) {
        this.selectedImage = image;
        this.selectedText = text;
    }

    @HostListener('document:click', ['$event'])
    onDocumentClick(event
                    :
                    Event
    ) {
        const clickedElement = event.target as HTMLElement;

        if (!this.elementRef.nativeElement.contains(clickedElement) && this.isMenuOpen) {
            this.closeMenu();
        }
    }

    @HostListener('window:resize', ['$event'])
    onResize(event
             :
             any
    ) {
        this.checkScreenSize();
    }

    checkScreenSize() {
        const screenWidth = window.innerWidth;
        if (screenWidth <= 768) { // Mobile screen breakpoint (adjust as needed)
            this.mobileFunction();
        }
    }

    mobileFunction() {
        console.log('Mobile screen detected. Executing function...');
        setTimeout(() => {
            this.phoneViewMenuOpen = false;
        }, 100);
    }

    goTo(url
         :
         any
    ) {
        window.open(url, '_blank');
    }
}
